import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Modal, Table
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import axios from "axios";
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import _ from 'lodash';
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';

var url = window.location.hostname;
var port = window.location.port;



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    
    this.onReasonChange = this.onReasonChange.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleReason = this.toggleReason.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.enterReason = this.enterReason.bind(this);
    this.processData = this.processData.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    this.checkedSingle = this.checkedSingle.bind(this);
    this.toggleReasonCancel = this.toggleReasonCancel.bind(this);
    /*this.ExcelDateToJSDate = this.ExcelDateToJSDate.bind(this);*/
    /*this.toShortFormat = this.toShortFormat.bind(this);*/
    this.state = {
      showReasonCode: false,
      reasonDropdown: [],
      showPassword: false,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      genloading1: false,
      file: {},
      data: [],
      cols: [],
      modal: false,
      modalFailed: false,
      showAllItem: false,
      disabledReasonBtn : true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      dateNewVal: '',
      stn_date_formate: '',
	  loading_overlay: false,
      table_header: ['GRN Number' , 'GRN Line Number' , 'Basepack Code', 'Basepack Description' , 'CBU Code', 'SKU7 Code' , 'LB SKU ID' , 'LB SKU Product Name' , 'PKD' , 'Batch' , 'MRP', 'UPC' , 'Received ICLD Quantity' , 'Tester Quantity' , 'Tester Flag' , 'STN Date' , 'STN Number' , 'Storage Type' , 'Fast Moving', 'Crate ID' ,'GRN Date Time', 'Remarks' ],
      validation: {
        "Bin Master": {
          "GRN Number": "string",
          "GRN Line Number": "number",
          "Basepack Code": "string",
          "Level": "number",
          "Rack": "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },
      },
    };
  }


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));

    
  }

  toggleReason() {
    this.setState(prevState => ({ modalReason: !prevState.modalReason }));

    
  }

  toggleReasonCancel(){
    this.setState({
      modalReason: false
    })

    let data = this.state.data

     data.map((item , i) => {
      if(item.isChecked === true){
        
        data[i].isChecked = false

        
        
      } 
    })

     

    this.setState({
      showErrorMessage: false,
      data : data
    })
  }

  enterReason(){
    this.toggleReason();
  }

  checkedSingle(index){
  console.log(this.state.data);
  let newData = this.state.data;
  if (newData[index].isChecked === false) {
    newData[index].isChecked  =  true;
  }else if (newData[index].isChecked === true) {
    newData[index].isChecked  =  false;
  }


  
  console.log(newData);
  this.setState({
    genloading1: !this.state.genloading1,
    data: newData
  })

  for(var i = 0 ; i< newData.length ; i++){
    if (newData[i].isChecked == true) {
      this.setState({
        disabledReasonBtn: false,
        genloading1: !this.state.genloading1,
      })

      return false
    }
  }
   

      
}

  SuccessConfirmtoggle() {
    this.setState(prevState => ({ SuccessConfirmmodal: !prevState.SuccessConfirmmodal }));

    
  }

  onReasonChange(e){
    let data = this.state.data
    
    data.map((item , i) => {
          if(item.isChecked === true){
            if(this.state.reasonCodeNeeded === true){
                var index = e.nativeEvent.target.selectedIndex;
                data[i].reason = e.target.value;
                data[i].reason_text = e.nativeEvent.target[index].text;
				data[i].reason_code_id = e.target.value;
			}else{
				data[i].reason = e;
                data[i].reason_text = e
			}
            
          } 
        })

        this.setState({
          data : data
        })

        console.log(this.state.data);

    /*this.setState({
      data: data.map((item, i) => i === index ? { ...item, reason: value } : item),
     
    })*/



    console.log(this.state.data);

  }



  componentWillMount(){
       
      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41" + ":8090";

      }else{
        url= window.location.hostname + port;
      }

      var cookieUsername = this.getCookie('token');
      var Location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: Location
      }, () => {this.fetchReason()})

      localStorage.setItem('userName' , username);
    }



   

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }

  SuccessConfirmoktoggle(){
    this.setState({
      SuccessConfirmmodal: false
    })

    window.location.reload();
    /*window.location.href="/putaway/printPutaway";*/
  }

  processData(){

    this.setState({
      loadingconfirmbtn: true,
      processData: true,
      showErrorMessage: false,
	  loading_overlay: true
    })

      var arr = []
     console.log(JSON.stringify(this.state.data.length));
    
      
      for(var i = 0; i < this.state.data.length; i++) {
          
          console.log(this.state.data[i]['GRN Number']);
        var orderData  = {};
          orderData['GRNNumber'] = this.state.data[i]['GRN Number'];
          orderData['GNRLineNumber'] = this.state.data[i]['GRN Line Number'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['basePackDescription'] = this.state.data[i]['Basepack Description'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['receivedICLDQuantity'] = this.state.data[i]['Received ICLD Quantity'];
          orderData['testerQuantity'] = this.state.data[i]['Tester Quantity'];
          orderData['testerFlag'] = this.state.data[i]['Tester Flag'];
          orderData['stnDate'] = this.state.data[i]['STN Date'];
          orderData['stnNumber'] = this.state.data[i]['STN Number'];
          orderData['storageType'] = this.state.data[i]['Storage Type'];
          orderData['fastMoving'] = this.state.data[i]['Fast Moving'];
          if (this.state.data[i]['Crate ID'] === undefined) {
            orderData['crateId'] = "";
          }else{
            orderData['crateId'] = this.state.data[i]['Crate ID'];
          }
          
          orderData['grnDateTime'] = this.state.data[i]['GRN Date Time'];

          if (this.state.data[i]['Remarks'] === undefined) {
            orderData['remarks'] = "";
          }else{
            orderData['remarks'] = this.state.data[i]['Remarks'];
          }
          
          /*orderData['remarks'] = 'dfghjk';*/

          
          arr.push(orderData);
      }

      console.log(arr);
      console.log(this.state.table_header.length);

      /*this.state.data.forEach(function(jsonobj){
            this.state.table_header.forEach(function(header_text){
              if (jsonobj[header_text] == undefined){
                jsonobj[header_text] = "";
            }
          });
      });*/

     
        let data = this.state.data
        data.map((item , i) => {
          if((item.reason_needed === true || item.reason_code_needed === true) && !item.reason){
            
            data[i].error_message = "Please enter reason"

            this.setState({
              showErrorMessage: true
            })
            
          } else{
             data[i].error_message = "validated"
          }
        })

        this.setState({
          data: data,
          showData: !this.state.showData,
          genloading1: !this.state.genloading1,
          loadingconfirmbtn: false
        })

        for (var i = 0; i < this.state.data.length; i++) {
          if (this.state.data[i].error_message === "Please enter reason") {
             this.setState({
              genloading1: !this.state.genloading1,
            })
            return false;
          }
        }


        console.log(this.state.data);



      /*if (this.state.responseFailLBSKUData.failure_response.length>0) {
          $(".error_file_uploaded").css('display', 'block');
        }else{
          
       $(".error_file_uploaded").css('display', 'none');*/

       this.setState({
        disabledBtn: true
       })
       const payload = {
        arr_data: this.state.data,
        location: this.state.selectedLocation,
        create: true,
      };
    
    API.post('/dispatch/dispatchConf/v1/', { param: payload })
      
      .then((response) =>  {

        
        this.setState({
          responseFailLBSKUData: response.data,
          responseSuccessLBSKUData: response.data,
		  loading_overlay:false,	
          modalFailed: false,
          loadingconfirmbtn: false,
          disabledBtn: true
        })

        this.SuccessConfirmtoggle();

       

        console.log(this.state.data);
      })
      .catch(function (error) {
        
        
    });
    /*}*/


  }

  togglePressCancel(){
      this.setState({
        showInvalidItem: false,
        modalFailed: false,
      },() => {
		if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
		}
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
		})

  }


  


 /*handleFile() {
    console.log('dfghjmk');
    
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
      
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      
      const data = XLSX.utils.sheet_to_json(ws);
     
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
        console.log(JSON.stringify(this.state.data, null, 2));
      });
 
    };*/
 
    /* var arr = []
     console.log(JSON.stringify(this.state.data.length));
    
      
      for(var i = 0; i < this.state.data.length; i++) {
          
          console.log(this.state.data[i]['GRN Number']);
        var orderData  = {};
          orderData['GRNNumber'] = this.state.data[i]['GRN Number'];
          orderData['GNRLineNumber'] = this.state.data[i]['GRN Line Number'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['basePackDescription'] = this.state.data[i]['Basepack Description'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['receivedICLDQuantity'] = this.state.data[i]['Received ICLD Quantity'];
          orderData['testerQuantity'] = this.state.data[i]['Tester Quantity'];
          orderData['testerFlag'] = this.state.data[i]['Tester Flag'];
          orderData['stnDate'] = this.state.data[i]['STN Date'];
          orderData['stnNumber'] = this.state.data[i]['STN Number'];
          orderData['storageType'] = this.state.data[i]['Storage Type'];
          orderData['fastMoving'] = this.state.data[i]['Fast Moving'];
          orderData['crateId'] = this.state.data[i]['Crate ID'];
          orderData['grnDateTime'] = this.state.data[i]['GRN Date Time'];
          orderData['remarks'] = 'dfghjk';

          
          arr.push(orderData);
      }

      console.log(arr);


      axios
    .post(('http://3.215.84.36:8088/picking/inv_upload/v1/' , 

      {

        arr_data: arr,
        location: 'bhi',
        create: false,
      },

     {
       headers: {
            'Content-Type': 'application/json'
            
          } 

     }
     

     )
      .then((response) =>  {

        console.log(response);
       

      })
      .catch(function (error) {
        
        
    });*/
  /*}*/


  
  

/*toShortFormat(){
  var month_names =["Jan","Feb","Mar",
                      "Apr","May","Jun",
                      "Jul","Aug","Sep",
                      "Oct","Nov","Dec"];
    
    var day = this.getDate();
    var month_index = this.getMonth();
    var year = this.getFullYear();
    
    var stn_date=  "" + day + "-" + month_names[month_index] + "-" + year;
    this.setState({
      stn_date_formate : stn_date,
    })
}*/

  handleFile() {
    /* Boilerplate to set up FileReader */
    this.setState({
      loading: true
    })
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true, cellDates: true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws,{raw:false,dateNf: 'YYYY-MM-DD'})
      console.log(data[0])
      // const formattedData = data.map(item => {
      //   if(item['stnDate'])
      // })
      /* Update state */
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
        console.log(JSON.stringify(this.state.data, null, 2));
        /*let invalidItems = this.state.data.filter(item => !this.validateItem(item))*/



        var arr = []
     console.log(JSON.stringify(this.state.data.length));
    
      
      for(var i = 0; i < this.state.data.length; i++) {
        // var backToDate = new Date(this.state.data[i]['STN Date']);
        // console.log(backToDate);
        // this.ExcelDateToJSDate(this.state.data[i]['STN Date']);
        /*this.toShortFormat(this.state.dateNewVal)*/

        /*const date = this.state.dateNewVal;
        const formattedDate = date.toLocaleDateString('en-GB', {
          day: 'numeric', month: 'short', year: 'numeric'
        }).replace(/ /g, '-');
        console.log(formattedDate);*/
         

       /* var utc_days  = Math.floor(this.state.data[i]['STN Date'] - 25569);
       var utc_value = utc_days * 86400;                                        
       var date_info = new Date(utc_value * 1000);

       var fractional_day = this.state.data[i]['STN Date'] - Math.floor(this.state.data[i]['STN Date']) + 0.0000001;

       var total_seconds = Math.floor(86400 * fractional_day);

       var seconds = total_seconds % 60;

       total_seconds -= seconds;

       var hours = Math.floor(total_seconds / (60 * 60));
       var minutes = Math.floor(total_seconds / 60) % 60;

       return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);


    var month_names =["Jan","Feb","Mar",
                      "Apr","May","Jun",
                      "Jul","Aug","Sep",
                      "Oct","Nov","Dec"];
    
    var day = this.getDate();
    var month_index = this.getMonth();
    var year = this.getFullYear();
    
    var dateFormate = day + "-" + month_names[month_index] + "-" + year;
          */
          console.log(this.state.data[i]['GRN Number']);
        var orderData  = {};
          orderData['GRNNumber'] = this.state.data[i]['GRN Number'];
          orderData['GNRLineNumber'] = this.state.data[i]['GRN Line Number'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['basePackDescription'] = this.state.data[i]['Basepack Description'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['receivedICLDQuantity'] = this.state.data[i]['Received ICLD Quantity'];
          orderData['testerQuantity'] = this.state.data[i]['Tester Quantity'];
          orderData['testerFlag'] = this.state.data[i]['Tester Flag'];

          orderData['stnDate'] = this.state.data[i]['STN Date'];
          orderData['stnNumber'] = this.state.data[i]['STN Number'];
          orderData['storageType'] = this.state.data[i]['Storage Type'];
          orderData['fastMoving'] = this.state.data[i]['Fast Moving'];
          if (this.state.data[i]['Crate ID'] === undefined) {
            orderData['crateId'] = "";
          }else{
            orderData['crateId'] = this.state.data[i]['Crate ID'];
          }
          
          orderData['grnDateTime'] = this.state.data[i]['GRN Date Time'];

          if (this.state.data[i]['Remarks'] === undefined) {
            orderData['remarks'] = "";
          }else{
            orderData['remarks'] = this.state.data[i]['Remarks'];
          }
          
          /*orderData['remarks'] = 'dfghjk';*/

          
          arr.push(orderData);
      }

      console.log(arr);
      console.log(this.state.table_header.length);

      /*this.state.data.forEach(function(jsonobj){
            this.state.table_header.forEach(function(header_text){
              if (jsonobj[header_text] == undefined){
                jsonobj[header_text] = "";
            }
          });
      });*/
      const payload = {
        arr_data: this.state.data,
        location: this.state.selectedLocation,
        create: false,
      };
      API.post('/dispatch/dispatchConf/v1/',{param:payload})
     
      .then((response) =>  {

        console.log("length"+response.data.failure_response.length);

        console.log(response.data);

        let data = this.state.data

        data.map(item => {
          item.status_val = 300
        })

        console.log(data);

        response.data.failure_response.map(item => {
          if(item.status_code == 409){
            const index = _.findIndex(data, dataItem => item.lb_sku_id == dataItem['LB SKU ID'] && item.pkd == dataItem['PKD'] && item.ptl_id == dataItem['PTL ID'])
            data[index].error = item.message
            data[index].reason_needed = item.reason_needed
			data[index].reason_code_needed = item.reason_code_needed
            data[index].isChecked = false

            if (data[index]['Total Packed Quantity'] == 0) {
              data[index].status_val = 100
              data[index].reason = "zero Quantity Picked"


            }else{
              data[index].status_val = 200
              data[index].reason = ""
            }

            
          }/*else{
             const index = _.findIndex(data, dataItem => item.lb_sku_id !== dataItem['LB SKU ID'] )
            data[index].status_val = 200

          }*/
        })

        console.log(data);

        data.sort((a,b) => {

          if (a.status_val < b.status_val) return -1;
          if (a.status_val > b.status_val) return 1;
          return 0;

        })

       

        

        if (response.data.failure_response.length>0) {
          this.toggleFailed();
          
          this.setState({
            showError: true,
          })
        }else{
          this.toggle();
          
        }

        

     console.log(data);

         this.setState({
          responseFailLBSKUData: response.data,
          loading: false,
          responseSuccessLBSKUData: response.data,
          data: data,
          showAllItem: true,

        })

        console.log(this.state.data);

        if (response.data.failure_response.length>0) {
          /*console.log(response.data.failure_response.length);*/
		  
		  
            this.setState({
                showProceedbtn: true,
                showReasonbtn: true
              })
			  
          for(var i = 0 ; i< response.data.failure_response.length ; i++){
            /*if (response.data.failure_response[i].status == false) {
              this.setState({
                showProceedbtn: false
              })

              return false
               
            } else{
                if(response.data.failure_response[i].reason_code_needed === true){
					this.setState({reasonCodeNeeded: true});
                }else{
					this.setState({reasonCodeNeeded: false});
                }
                this.setState({
                showProceedbtn: true,
                showReasonbtn: true
              })
              
            }*/
			if(response.data.failure_response[i].reason_code_needed === true){
					this.setState({reasonCodeNeeded: true});
					return false;
                }else{
					this.setState({reasonCodeNeeded: false});
                }
          }
         

          console.log(this.state.showProceedbtn);
        }else if (response.data.failure_response.length===0){
          console.log(response.data.failure_response.length);
          this.setState({
            showProceedbtn: true
          })
        }
        

       

        console.log(this.state.data);

        console.log(this.state.data);
		if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
		}
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');


      })
      .catch(function (error) {
        
        
    });



      });
 
    };
 
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    };
  }

  handleChange(evt) {
    const files = evt.target.files;
    if (files && files[0]) this.setState({ file: files[0] });

    var file1 = evt.target.value
    var fileArray1 = evt.target.value.split('.')
    var extension1 = fileArray1[fileArray1.length - 1];
    if (document.getElementById("my_file_input") !== null) {
      document.getElementById("my_file_input").style.color = "";
      document.getElementById("picking_label").style.display = "none";
    }
    if(extension1 != 'xlsx' && extension1 != 'csv' && extension1 != 'xls'){
    
      $(".upload_error").css('display', 'block');
      $(".upload_success").css('display', 'none');
    }else {
      $(".upload_success").css('display', 'block');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
    }
  };

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  fetchReason = () => {
    const payload = {
      location: this.state.selectedLocation,
      job_type: "DP",
  };

API.post('/stock/fetchReasons/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log(data);
        let reasonDropdown = [...this.state.reasonDropdown];
        
        this.setState({reasonDropdown: data}, () => {console.log(this.state.reasonDropdown)})
      })
      .catch(function (error) {});
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { modalFailed, modalReason } = this.state;
    const { SuccessConfirmmodal } = this.state;

    return (
      <Col xl={12}>
	  {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
              
            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div className="form__form-group col-xl-6">
               
                <div className="form__form-group-field">
                  <div className="col-xl-12" style={{border: "1px solid #ced4da"}}>
                  <input  style={{paddingTop: 8,  height: 38,color: "transparent",width:"23%",border:"0px"}}
                    name="defaultInput"
                    component="input"
                    type="file"
                    placeholder="Default Input"
                    id="my_file_input" 
                    onChange={this.handleChange} 
                  />
				  <label for="files" id="picking_label">
                    Select and Upload Dispatch Confirmation Sheet
                  </label>
                  <div className="col-xl-12">
                  <span style={{display: 'none' , color:'red'}} className="upload_error"> Invalid file format. Please select .xls, .xlsx, .csv file format </span>
                  <span style={{display: 'none' , color:'green', marginTop: 8}} className="upload_success"> Valid file format </span>
                  </div>
                  </div>
                  
                </div>
                
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                    <Button className="btn-sm button_enable " style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }} id="button_enable" onClick={this.handleFile} >
                    {this.state.loading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    Proceed
                    </Button>
                </ButtonToolbar>
              </div>
            
            </form>
			<div className="notes" style={{paddingTop:'15px'}}>		
              <p style={{marginBottom: '13px',fontSize: '15px'}}><b>Note</b> : 1. Download the Dispatch Confirmation Sheet from TP and upload here. (No changes required).</p>
			 </div> 
          </CardBody>


          {
            this.state.showInvalidItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>LB SKU ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailLBSKUData.failure_response.length>0 && (
                      this.state.responseFailLBSKUData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessLBSKUData.success_response.length>0 && (
                      this.state.responseSuccessLBSKUData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }



          {
            this.state.showAllItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div className="table_header" style={{borderBottom: 0}}>
                   <ButtonToolbar className="form__button-toolbar" style={{width: 145, float: 'left'}}>
                      {this.state.showProceedbtn && (
                      <Button color="primary" disabled={this.state.disabledBtn} className="btn-sm show_confirm_button" onClick={this.processData} type="submit">
                      {this.state.loadingconfirmbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    } 
                      Confirm</Button>
                      )}
                    </ButtonToolbar>

                     <ButtonToolbar className="form__button-toolbar" style={{width: 200, float: 'left', marginTop: 0}}>
                      {this.state.showReasonbtn && (
                      <Button color="primary" disabled={this.state.disabledReasonBtn} className="btn-sm show_confirm_button" onClick={this.enterReason} type="submit">
                    
                      Enter Reason</Button>
                      )}
                    </ButtonToolbar>

                    { this.state.showErrorMessage && (
                    <div style={{paddingTop: 4, width: 300, float: 'left'}}>
                      <span style={{fontWeight: 'bold' , color: 'red'}}> Please enter a valid reason </span>

                    </div>
                    )}

                  </div>
                  <div className="table_val1" style={{ marginTop: 15 }}>
                  <Table  responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th> Action </th>
                        <th>Response </th>
                        
                        <th>Reason</th>
                        <th>PTL ID</th>
                        <th>CBU Code</th>
                        <th>LB SKU ID</th>
                        <th> LB SKU Product Name </th>
                        <th>PKD</th>
                        <th>Batch</th>
                        <th>MRP</th>
                        <th>UPC</th>
                        <th>Quantity</th>
                        
                       
                       
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                      {
                      
                      this.state.data.map((item, index) => (
                        <tr>
							
                           {  (item['reason_needed'] === true || item['reason_code_needed'] === true) ? (
							   
                            <td>
							
                            <input type="checkbox" value={item.isChecked} checked={item.isChecked} onChange={() => this.checkedSingle(index, item)}/>
                             {/*<textarea style={{width: 150}} onChange={(e) => this.onReasonChange(index , e.target.value)}  placeholder="Enter Reason" className="form-control" id="exampleFormControlTextarea1" rows="2" /> <br/>*/}
                              {((item.reason_needed == true || item.reason_code_needed == true) && !item.reason) && (

                              <span style={{color: 'red', marginLeft: 4}}>{item.error_message}</span>
                            )}
                             </td>

                            ) : (
                            <td> </td>

                            )
                          }


                          { item['error'] ? (
                            <td style={{color: 'red'}}> {item['error']} </td>

                            ) : (
                            <td style={{ color: 'green'}}> No Error </td>

                            )
                          }

                         

                          { item['reason_text'] ? (
                            <td style={{fontWeight: 'bold'}}> {item['reason_text']} </td>

                            ) : (
                            <td></td>

                            )
                          }

                          {/*{ item['reason_needed'] === true ? (
                            <td> 
                             <textarea style={{width: 150}} onChange={(e) => this.onReasonChange(index , e.target.value)}  placeholder="Enter Reason" className="form-control" id="exampleFormControlTextarea1" rows="2" /> <br/>
                              {item.error_message === "Please enter a valid reason" && (

                              <span style={{color: 'red'}}>{item.error_message}</span>
                            )}
                             </td>

                            ) : (
                            <td> </td>

                            )
                          }
                         */}
                          <td>{item['PTL ID']}</td>
                          <td>{item['CBU Code']}</td>
                          
                          <td>{item['LB SKU ID']}</td>
                          <td> {item['LB SKU Product Name']} </td>
                          
                          <td>{item['PKD']}</td>
                          <td>{item['Batch']}</td>
                          <td>{item['MRP']}</td>
                          <td>{item['UPC']}</td>
                          <td>{item['Total Packed Quantity']} pcs</td>

                           

                          
                          
                          
                        </tr>
                      ))
                    }


                    </tbody>
                  </Table>
                  </div>
                </CardBody>
            )
          }










        </Card>






        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.toggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
             <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors, Please Upload a valid file. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button  className="modal_cancel"  onClick={this.togglePressCancel}>Cancel</button>
            <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12, display: 'none'}} className="modal_ok"  onClick={this.togglePressCancel}>Procced</Button>
          </ButtonToolbar>
        </Modal>



        <Modal
          isOpen={modalReason}
          toggle={this.toggleReason}

          style={{maxWidth: 578}}
        >
          <div className="modal__header" style={{backgroundColor: '#70bbfd'}}>
            <h4 className="text-modal  modal__title" style={{color: '#fff', paddingTop: 10}}>Enter Reason</h4>
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
             <div style={{width: '30%', float:'left',textAlign: 'center', fontWeight: 'bold'}}>
                Enter Reason
              </div>

              {this.state.reasonCodeNeeded ? (
				<select
                    onChange={(e) => this.onReasonChange(e)}
                    style={{ padding: 4, borderRadius: 2, width: "54%" }}
                    //disabled={this.state.showReasonCode}
                    
                  >
                  <option value=''>Select Reason</option>
				  {this.state.reasonDropdown.map(reason => <option value={reason["id"]}>{reason["description"]}</option> )}
                  </select>
			  ): (
              <div style={{width: '50%', float:'left',textAlign: 'right'}}>
                <textarea style={{width: 400 , fontSize: 12}} onChange={(e) => this.onReasonChange(e.target.value)}  placeholder="Enter Reason" className="form-control" id="exampleFormControlTextarea1" rows="2" />
              </div>
			  )}
          </div>
          <ButtonToolbar className="modal__footer">
            <button className="modal_cancel"  onClick={this.toggleReason}>Cancel</button>
            <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.toggleReasonCancel}>Proceed</Button>
          </ButtonToolbar>
        </Modal>




        <Modal
          isOpen={SuccessConfirmmodal}
          toggle={this.SuccessConfirmtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.SuccessConfirmtoggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccessConfirmoktoggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));